<template>
  <div v-if="menu && menuItems">
    <XsMenu
      v-if="$vuetify.breakpoint.xsOnly"
      :menu="menu"
      :menuItems="menuItems"
    />
    <Menu v-else :menu="menu" :menuItems="menuItems" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { slug } from 'github-slugger';
import throttle from 'lodash.throttle';
import Menu from "@/components/Menu/Menu.vue";
import XsMenu from "@/components/Menu/Xs/Menu.vue";

export default {
  name: "MenuView",
  components: { Menu, XsMenu },
  computed: {
    ...mapGetters("menu", { allMenuItems: 'bySection', selectedSection: 'selectedSection' }),
    ...mapGetters("menu", ["paginatedMenuItems"]),
    ...mapState({
      menu: (state) =>
        state.departments.data.find((dept) => dept.category_id === "Menu"),
    }),
    menuItems() {
      if (!this.allMenuItems || !this.selectedSection) return this.allMenuItems;

      return {
        ...this.allMenuItems,
        [this.selectedSection]: this.paginatedMenuItems,
      };
    },
  },
  created() {
    this.handleScroll = throttle(() => {
      this.checkIfNeedMoreProducts();
    }, 300);
    document.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions('menu', ['selectSection']),
    checkIfNeedMoreProducts() {
      const pixelsFromBottomToMakeAnotherRequest = 890;
      const scrollHeight = document.body.clientHeight;
      const scrollPos = window.innerHeight + window.scrollY;
      const timeToFetch =
        (scrollHeight - pixelsFromBottomToMakeAnotherRequest >= scrollPos) / scrollHeight === 0;
      if (timeToFetch && this.$store.getters['menu/hasMoreMenuItems']) {
        this.$store.commit('menu/UPDATE_PAGE');
      }
    },
    updateSectionFromHash() {
      if (this.allMenuItems) {
        let sectionName;
        if (this.$route.hash) {
          const hash = this.$route.hash.replace('#', '');
          sectionName = Object.keys(this.allMenuItems).find(
            section => slug(section.replace(/^\d/, 'abc$&')) === hash || slug(section) === hash,
          );
        }

        if (!sectionName) {
          sectionName = Object.keys(this.allMenuItems)[0];
        }

        if (sectionName) {
          this.selectSection(sectionName);
        }
      }
    },
  },
  watch: {
    '$route.hash': {
      handler: 'updateSectionFromHash',
      immediate: true,
    },
    allMenuItems: {
      handler: 'updateSectionFromHash',
      immediate: true,
    },
  },
};
</script>
